import { isNullish } from 'remeda';
import { AttributeText } from 'src/graphql/entities/custom-attributes/field-view-registry/components/attribute-text';
import { EmptyValue } from 'src/graphql/entities/custom-attributes/field-view-registry/components/empty-value';
import { CustomAttributeReadProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';

export const NumberView = ({ value }: CustomAttributeReadProps) => {
  const numberValue = getKindLikeValueSafely(value, 'number');

  if (isNullish(numberValue)) {
    return <EmptyValue />;
  }

  const formatted = numberValue.toLocaleString();

  return (
    <AttributeText
      title={formatted}
      sx={{
        display: 'block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '160px',
      }}
    >
      {formatted}
    </AttributeText>
  );
};
